import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';
import App from './App';
import './index.css';
import '../styles.css';
import './styles/theme.css';
import './styles/ai-workspace.css';
import './styles/owner-intelligence.css';
import './styles/i18n-rtl.css';
import { queryClient } from './config/queryClient';
import { initI18n } from './i18n/i18n';

// Bootstrap i18n before first paint (LocaleProvider syncs language after prefs load)
initI18n('en');

if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
  });
}

// Service worker is required for browser Web Push (prod + Vite PWA-enabled dev).
import('virtual:pwa-register')
  .then(({ registerSW }) => {
    registerSW({ immediate: true });
  })
  .catch(() => {
    /* PWA registration optional when plugin/virtual module unavailable */
  });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);

